import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../components/navbar/Navbar';
import Sidebar from '../../components/sidebar/Sidebar';
import AgbaContext from '../../context/agba/agbaContext';
import { LayoutPage } from './layoutStyle';

const Layout = () => {
  const agbaContext = useContext(AgbaContext);
  const { sideBar } = agbaContext;

  return (
    <LayoutPage sideBar={sideBar}>
      <Navbar />
      <Sidebar />
      <div className='page'>
        <span className='tags top-tags'>&lt;body&gt;</span>
        <Outlet />
        <span className='tags bottom-tags'>&lt;/body&gt;</span>
        <br />
        <span className='tags bottom-tag-html'>&lt;/html&gt;</span>
      </div>
    </LayoutPage>
  );
};

export default Layout;
